import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="homepage">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="logo">
            <h1>Heni</h1>
          </div>
          <nav className="nav">
            <a href="https://play.google.com/store/apps/details?id=com.heni.aiavatars" target="_blank" rel="noopener noreferrer">
              <button className="cta-button">Try Heni Now</button>
            </a>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Meet Heni Avatars — More Than Just AI Companions
              </h1>
              <p className="hero-description">
                The next generation of AI avatars that do more than chat — they live, play, and create with you.
              </p>
              <a href="https://play.google.com/store/apps/details?id=com.heni.aiavatars" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none'}}>
                <button className="cta-button-large">Try Heni Now</button>
              </a>
            </div>
            <div className="hero-image">
              <div className="phone-mockup">
                <div className="phone-screen">
                  <div className="app-header">
                    <span className="app-logo">heni</span>
                  </div>
                  <div className="avatar-container">
                    <div className="avatar">
                      <div className="avatar-face"></div>
                      <div className="avatar-body"></div>
                    </div>
                    <div className="avatar-glow"></div>
                  </div>
                  <div className="app-controls">
                    <div className="control-button game"></div>
                    <div className="control-button main"></div>
                    <div className="control-button chat"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">
                <div className="icon-game"></div>
              </div>
              <h3>Play Games Together</h3>
              <p>Enjoy a variety of fun and engaging games alongside your avatar.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">
                <div className="icon-create"></div>
              </div>
              <h3>Create with Your Avatar</h3>
              <p>Collaborate on creative projects and bring your ideas to life.</p>
            </div>
            <div className="feature">
              <div className="feature-icon">
                <div className="icon-support"></div>
              </div>
              <h3>24/7 Support & Companionship</h3>
              <p>Your avatar is always there to listen, talk, and provide company.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="bottom-cta">
        <div className="container">
          <h2>Never feel alone again with Heni.</h2>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage; 